

















































import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import * as ApiPath from '@/tcw/constant/ApiPath'

@Component({
  components: { TcwLayoutBasicTemplate }
})
export default class PasswordChangePage extends Mixins(BasePage, DataUpdateComponent) {
  private form = {
    oldPassword: '',
    newPassword: '',
    newPasswordKakunin: ''
  }

  get apiPath(): string {
    return ApiPath.Paths.UserPasswordChange.put
  }

  protected save(): void {
    this.startSaveProc()
  }

  protected async execSaveMain(): Promise<void> {
    // パスワード更新処理を実行
    await this.getWebApi().call(this.apiPath, 'PUT', this.form)
  }

  protected async afterSaveProc(): Promise<void> {
    this.$tcw.message({
      type: 'success',
      message: '保存しました'
    })
    // 勤怠一覧画面に遷移
    this.$router.push('/kintai/list')
  }
}
